import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

import '../Home/Home.css'
import './Inputs.css'
import Cidades from '../Cidades/Cidades.js'
import loadingGif from '../../assets/loading.gif'

const PAGE_SIZE = 30

const SETOR_OPCOES = [
    'Coordenação',
    'Revisita',
    'Arquivo',
    'Aguardando prazo',
    'Processo Ético',
    'Presidência',
    'Novo',
    'Assessoria Jurídica',
    'AJUR Contencioso Notícia Crime',
    'AJUR Contencioso Diversos',
    'AJUR Ações Ajuizadas',
    'AJUR Procedimento no MP',
    'AJUR Notícia Crime/Protocolados',
    'Processo Ético/Instaurados',
    'Análise Fiscal',
    'TAC/Ausência de Registro'
]

const SETOR_DESTINO_OPCOES = [
    'Análise do Fiscal',
    'Coordenação',
    'Revisita',
    'Arquivo',
    'Processo Ético',
    'Presidência',
    'Novo',
    'Assessoria Jurídica',
    'AJUR Contencioso Notícia Crime',
    'AJUR Contencioso Diversos',
    'AJUR Ações Ajuizadas',
    'AJUR Procedimento no MP',
    'Administrativo',
    'Análise Fiscal',
    'TAC/Ausência de Registro'
]

function uniq(arr) {
    return Array.from(new Set(arr))
}

function toArr(v) {
    if (Array.isArray(v)) return v
    if (v === undefined || v === null || v === '') return []
    return [v]
}

function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n))
}

export default class Fiscalizacao extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                user: localStorage.nome,
                filtroQtd: 0,
                filtros: [],
                valoresFiltros: []
            },
            items: [],
            hasNext: false,
            page: 1,
            fiscais: [],
            loaded: false,
            municipios: [],
            anosDisponiveis: this.getAnosDisponiveis(),
            loading: false,
            limitMode: 'recent'
        }

        this.busca = this.busca.bind(this)
        this.fetchPage = this.fetchPage.bind(this)
        this.addFiltro = this.addFiltro.bind(this)
        this.selectFiltro = this.selectFiltro.bind(this)
        this.setValor = this.setValor.bind(this)
        this.toggleValor = this.toggleValor.bind(this)
        this.handleUf = this.handleUf.bind(this)
        this.nextPage = this.nextPage.bind(this)
        this.prevPage = this.prevPage.bind(this)
        this.setLimitMode = this.setLimitMode.bind(this)
    }

    getAnosDisponiveis() {
        const anoAtual = new Date().getFullYear()
        const anos = []
        for (let a = anoAtual; a >= anoAtual - 5; a--) anos.push(String(a))
        return anos
    }

    componentDidMount() {
        const url = '/api/user/getFiscais'
        axios(url)
            .then(resp => {
                this.setState({ fiscais: Array.isArray(resp.data) ? resp.data : [] })
            })
            .catch(error => {
                alert((error && error.response && error.response.data) || 'Erro ao carregar fiscais')
            })
    }

    getOrder() {
        return this.state.limitMode === 'oldest' ? 'oldest' : 'recent'
    }

    setLimitMode(e) {
        const limitMode = e && e.target ? e.target.value : 'recent'
        this.setState({ limitMode, page: 1 }, () => {
            if (this.state.loaded) this.fetchPage(1)
        })
    }

    busca() {
        this.setState({ page: 1 }, () => this.fetchPage(1))
    }

    fetchPage(p) {
        const page = clamp(Number(p) || 1, 1, 999999999)
        const url = '/api/paf/buscaSetor'
        const body = {
            ...this.state.ficha,
            paginate: true,
            page,
            limit: PAGE_SIZE,
            order: this.getOrder()
        }

        this.setState({ loading: true, loaded: false })

        axios
            .post(url, body)
            .then(resp => {
                const data = resp && resp.data ? resp.data : {}
                const items = Array.isArray(data.items) ? data.items : []
                const hasNext = !!data.hasNext

                this.setState({
                    items,
                    hasNext,
                    loaded: true,
                    loading: false,
                    page
                })
            })
            .catch(error => {
                this.setState({ loading: false })
                alert((error && error.response && error.response.data) || 'Erro na busca')
            })
    }

    nextPage() {
        if (this.state.loading || !this.state.hasNext) return
        this.fetchPage((this.state.page || 1) + 1)
    }

    prevPage() {
        if (this.state.loading) return
        const prev = (this.state.page || 1) - 1
        if (prev < 1) return
        this.fetchPage(prev)
    }

    addFiltro(e) {
        const { name } = e.target
        this.setState(prev => {
            const ficha = { ...prev.ficha }
            const qtd = ficha.filtroQtd || 0

            if (name === 'mais') {
                ficha.filtroQtd = qtd + 1
                ficha.filtros = [...(ficha.filtros || []), '']
                ficha.valoresFiltros = [...(ficha.valoresFiltros || []), '']
            } else {
                if (qtd <= 0) return null
                ficha.filtroQtd = qtd - 1
                ficha.filtros = (ficha.filtros || []).slice(0, -1)
                ficha.valoresFiltros = (ficha.valoresFiltros || []).slice(0, -1)
            }

            return { ficha }
        })
    }

    selectFiltro(tipo, index) {
        this.setState(prev => {
            const ficha = { ...prev.ficha }
            const filtros = [...(ficha.filtros || [])]
            const valores = [...(ficha.valoresFiltros || [])]

            filtros[index] = tipo

            if (tipo === 'alerta') valores[index] = true
            else if (tipo === 'setor' || tipo === 'setorDestino' || tipo === 'documentos.funcionario' || tipo === 'anoCriacao' || tipo === 'tipo') valores[index] = []
            else valores[index] = ''

            ficha.filtros = filtros
            ficha.valoresFiltros = valores

            return { ficha }
        })
    }

    setValor(valor, index) {
        this.setState(prev => {
            const ficha = { ...prev.ficha }
            const valores = [...(ficha.valoresFiltros || [])]
            valores[index] = valor
            ficha.valoresFiltros = valores
            return { ficha }
        })
    }

    toggleValor(valor, index) {
        this.setState(prev => {
            const ficha = { ...prev.ficha }
            const valores = [...(ficha.valoresFiltros || [])]
            const atual = toArr(valores[index])
            const existe = atual.includes(valor)
            const novo = existe ? atual.filter(v => v !== valor) : [...atual, valor]
            valores[index] = uniq(novo)
            ficha.valoresFiltros = valores
            return { ficha }
        })
    }

    handleUf(valor, index) {
        this.setValor(valor, index)
        if (valor === 'AL' || valor === 'PB' || valor === 'PE' || valor === 'RN') {
            const cidades = Cidades[valor] || []
            this.setState({ municipios: cidades })
        } else {
            this.setState({ municipios: [] })
        }
    }

    render() {
        const { loading, limitMode, page, items, hasNext } = this.state
        const totalOnPage = Array.isArray(items) ? items.length : 0
        const showingFrom = totalOnPage ? (page - 1) * PAGE_SIZE + 1 : 0
        const showingTo = totalOnPage ? (page - 1) * PAGE_SIZE + totalOnPage : 0

        return (
            <>
                <div>
                    <button
                        name="mais"
                        className="btn btn-success mt-3 mr-2"
                        style={{ height: '6vh', width: '4vw' }}
                        onClick={this.addFiltro}
                        disabled={loading}
                    >
                        +
                    </button>
                    <button
                        name="menos"
                        className="btn btn-danger mt-3"
                        style={{ height: '6vh', width: '4vw' }}
                        onClick={this.addFiltro}
                        disabled={loading}
                    >
                        -
                    </button>
                </div>

                <div className="container form-group mx-auto row">
                    <div className="principal">Filtros:</div>
                    {this.renderFiltros()}
                    <div className="principal">Valores:</div>
                    {this.renderFiltroValor()}

                    <div className="col-12 mt-3" style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <button className="botaoEnviar" onClick={this.busca} disabled={loading}>
                            Buscar
                        </button>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ fontSize: '14px' }}>Ordenar:</div>
                            <select
                                className="input"
                                style={{ width: '240px' }}
                                value={limitMode}
                                onChange={this.setLimitMode}
                                disabled={loading}
                            >
                                <option value="recent">Mais recentes</option>
                                <option value="oldest">Mais antigas</option>
                            </select>
                        </div>
                    </div>

                    <div className="container mx-auto" style={{ position: 'relative' }}>
                        {loading ? (
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'rgba(255,255,255,0.75)',
                                    zIndex: 5,
                                    borderRadius: '8px'
                                }}
                            >
                                <img src={loadingGif} alt="Carregando..." style={{ width: '120px', height: '120px' }} />
                            </div>
                        ) : null}

                        <div className="text-center mx-auto">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                                <div style={{ fontSize: '14px', opacity: 0.9 }}>
                                    {totalOnPage ? `Mostrando ${showingFrom}–${showingTo}` : 'Sem resultados'}
                                </div>
                                <div style={{ fontSize: '14px', opacity: 0.9 }}>
                                    Página {page}
                                </div>
                            </div>

                            <table className="table mt-2">
                                <thead>
                                    <tr>
                                        <th>PROCESSO</th>
                                        <th>SITUAÇÃO</th>
                                        <th>ESTABELECIMENTO</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>{this.renderRows(items)}</tbody>
                            </table>

                            {this.state.loaded ? this.renderPaginacao(page, hasNext) : null}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    renderPaginacao(page, hasNext) {
        const loading = this.state.loading
        const canPrev = page > 1
        const canNext = !!hasNext

        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', paddingBottom: '18px' }}>
                <button className="btn btn-light" onClick={this.prevPage} disabled={loading || !canPrev}>
                    Anterior
                </button>

                <span style={{ fontSize: '14px', opacity: 0.9 }}>Página {page}</span>

                <button className="btn btn-light" onClick={this.nextPage} disabled={loading || !canNext}>
                    Próxima
                </button>
            </div>
        )
    }

    renderFiltros() {
        const filtros = []
        const qtd = this.state.ficha.filtroQtd || 0
        const loading = this.state.loading

        for (let n = 0; n < qtd; n++) {
            const val = (this.state.ficha.filtros || [])[n] || ''
            filtros.push(
                <div className="col-10 col-md-3" key={`filtro-${n}`}>
                    <select
                        className="input"
                        name="tipoBusca"
                        value={val}
                        onChange={e => this.selectFiltro(e.target.value, n)}
                        disabled={loading}
                    >
                        <option value=""></option>
                        <option value="data">Data</option>
                        <option value="anoCriacao">Ano de criação</option>
                        <option value="tipo">Categoria (Fisio/TO)</option>
                        <option value="numero">Número</option>
                        <option value="estabelecimento">Nome do Estabelecimento</option>
                        <option value="setor">Situação</option>
                        <option value="setorDestino">Setor Destino</option>
                        <option value="documentos.funcionario">Fiscal</option>
                        <option value="uf">Estado</option>
                        <option value="municipio">Cidade</option>
                        <option value="cep">Cep</option>
                        <option value="alerta">Alerta</option>
                        <option value="profissional">Profissional</option>
                    </select>
                </div>
            )
        }

        return filtros
    }

    renderFiltroValor() {
        const valores = []
        const qtd = this.state.ficha.filtroQtd || 0
        const loading = this.state.loading

        for (let n = 0; n < qtd; n++) {
            const filtro = (this.state.ficha.filtros || [])[n] || ''
            const valor = (this.state.ficha.valoresFiltros || [])[n]

            if (!filtro) {
                valores.push(<div className="col-10 col-md-3" key={`valor-${n}`} />)
                continue
            }

            if (filtro === 'data') {
                valores.push(
                    <div className="col-10 col-md-3" key={`valor-${n}`}>
                        <input
                            type="date"
                            className="input"
                            value={valor || ''}
                            onChange={e => this.setValor(e.target.value, n)}
                            disabled={loading}
                        />
                    </div>
                )
                continue
            }

            if (filtro === 'anoCriacao') {
                const selecionados = toArr(valor)
                valores.push(
                    <div className="col-10 col-md-3" key={`valor-${n}`}>
                        <div className="input" style={{ height: 'auto', padding: '10px', maxHeight: '220px', overflow: 'auto' }}>
                            {this.state.anosDisponiveis.map(ano => (
                                <label key={`ano-${n}-${ano}`} style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '6px' }}>
                                    <input
                                        type="checkbox"
                                        checked={selecionados.includes(ano)}
                                        onChange={() => this.toggleValor(ano, n)}
                                        disabled={loading}
                                    />
                                    <span>{ano}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                )
                continue
            }

            if (filtro === 'tipo') {
                const selecionados = toArr(valor)
                const opcoes = [
                    { value: 'FISIO', label: 'Fisioterapia' },
                    { value: 'TO', label: 'Terapia Ocupacional' }
                ]
                valores.push(
                    <div className="col-10 col-md-3" key={`valor-${n}`}>
                        <div className="input" style={{ height: 'auto', padding: '10px' }}>
                            {opcoes.map(op => (
                                <label key={`tipo-${n}-${op.value}`} style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '6px' }}>
                                    <input
                                        type="checkbox"
                                        checked={selecionados.includes(op.value)}
                                        onChange={() => this.toggleValor(op.value, n)}
                                        disabled={loading}
                                    />
                                    <span>{op.label}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                )
                continue
            }

            if (filtro === 'setor') {
                const selecionados = toArr(valor)
                valores.push(
                    <div className="col-10 col-md-3" key={`valor-${n}`}>
                        <div className="input" style={{ height: 'auto', padding: '10px', maxHeight: '220px', overflow: 'auto' }}>
                            {SETOR_OPCOES.map(op => (
                                <label key={`setor-${n}-${op}`} style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '6px' }}>
                                    <input
                                        type="checkbox"
                                        checked={selecionados.includes(op)}
                                        onChange={() => this.toggleValor(op, n)}
                                        disabled={loading}
                                    />
                                    <span>{op}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                )
                continue
            }

            if (filtro === 'setorDestino') {
                const selecionados = toArr(valor)
                valores.push(
                    <div className="col-10 col-md-3" key={`valor-${n}`}>
                        <div className="input" style={{ height: 'auto', padding: '10px', maxHeight: '220px', overflow: 'auto' }}>
                            {SETOR_DESTINO_OPCOES.map(op => (
                                <label key={`setorDestino-${n}-${op}`} style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '6px' }}>
                                    <input
                                        type="checkbox"
                                        checked={selecionados.includes(op)}
                                        onChange={() => this.toggleValor(op, n)}
                                        disabled={loading}
                                    />
                                    <span>{op}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                )
                continue
            }

            if (filtro === 'documentos.funcionario') {
                const selecionados = toArr(valor)
                valores.push(
                    <div className="col-10 col-md-3" key={`valor-${n}`}>
                        <div className="input" style={{ height: 'auto', padding: '10px', maxHeight: '220px', overflow: 'auto' }}>
                            {this.state.fiscais.map(f => {
                                const nome = (f && f.nome) || ''
                                if (!nome) return null
                                return (
                                    <label key={`fiscal-${n}-${nome}`} style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '6px' }}>
                                        <input
                                            type="checkbox"
                                            checked={selecionados.includes(nome)}
                                            onChange={() => this.toggleValor(nome, n)}
                                            disabled={loading}
                                        />
                                        <span>{nome}</span>
                                    </label>
                                )
                            })}
                        </div>
                    </div>
                )
                continue
            }

            if (filtro === 'uf') {
                valores.push(
                    <div className="col-7 col-md-3" key={`valor-${n}`}>
                        <select className="input" value={valor || ''} onChange={e => this.handleUf(e.target.value, n)} disabled={loading}>
                            <option value=""></option>
                            <option value="AL">AL</option>
                            <option value="PB">PB</option>
                            <option value="PE">PE</option>
                            <option value="RN">RN</option>
                        </select>
                    </div>
                )
                continue
            }

            if (filtro === 'municipio') {
                valores.push(
                    <div className="col-7 col-md-3" key={`valor-${n}`}>
                        <select className="input" value={valor || ''} onChange={e => this.setValor(e.target.value, n)} disabled={loading}>
                            <option value=""></option>
                            {this.renderMunicipios()}
                        </select>
                    </div>
                )
                continue
            }

            if (filtro === 'alerta') {
                valores.push(
                    <div className="col-10 col-md-3" key={`valor-${n}`}>
                        <input type="text" className="input" value="PAFs em Alerta" readOnly />
                    </div>
                )
                continue
            }

            valores.push(
                <div className="col-10 col-md-3" key={`valor-${n}`}>
                    <input type="text" className="input" value={valor || ''} onChange={e => this.setValor(e.target.value, n)} disabled={loading} />
                </div>
            )
        }

        return valores
    }

    renderMunicipios() {
        const municipios = Array.isArray(this.state.municipios) ? this.state.municipios : []
        return municipios.map(m => {
            const nome = (m && m.nome) || ''
            if (!nome) return null
            return (
                <option key={`mun-${nome}`} value={nome}>
                    {nome}
                </option>
            )
        })
    }

    renderRows(listSlice) {
        const list = Array.isArray(listSlice) ? listSlice : []

        return list.map(ficha => {
            const id = ficha && (ficha._id || ficha.id)
            const setor = (ficha && ficha.setor) || ''
            const numero = (ficha && ficha.numero) || ''
            const estabelecimento = (ficha && ficha.estabelecimento) || ''

            if (setor === 'Aguardando prazo') {
                let resto = '(Prazo não definido)'
                if (ficha && ficha.prazo) {
                    const hoje = new Date().getTime()
                    const prazo = Date.parse(ficha.prazo)
                    if (!Number.isNaN(prazo)) {
                        resto = String(Math.floor((prazo - hoje) / 86400000) + 1)
                    }
                }

                return (
                    <tr key={String(id || numero || Math.random())}>
                        <td>{numero}</td>
                        <td>
                            {setor}
                            {ficha && ficha.setorDestino ? `(${ficha.setorDestino})` : ''}
                            {' : '}
                            {resto} dias
                        </td>
                        <td>{estabelecimento}</td>
                        <td>
                            <Link to={`/documentosPaf/${ficha._id}`} target="_blank" params={ficha}>
                                <button
                                    style={{
                                        border: 'none',
                                        backgroundColor: '#28a745',
                                        paddingTop: '5px',
                                        paddingBottom: '5px',
                                        paddingLeft: '12px',
                                        paddingRight: '12px',
                                        borderRadius: '15px',
                                        color: '#FFFF'
                                    }}
                                >
                                    Abrir
                                </button>
                            </Link>
                        </td>
                    </tr>
                )
            }

            return (
                <tr key={String(id || numero || Math.random())}>
                    <td>{numero}</td>
                    <td>{setor}</td>
                    <td>{estabelecimento}</td>
                    <td>
                        <Link to={`/documentosPaf/${ficha._id}`} target="_blank" params={ficha}>
                            <button
                                style={{
                                    border: 'none',
                                    backgroundColor: '#28a745',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    paddingLeft: '12px',
                                    paddingRight: '12px',
                                    borderRadius: '15px',
                                    color: '#FFFF'
                                }}
                            >
                                Abrir
                            </button>
                        </Link>
                    </td>
                </tr>
            )
        })
    }
}
